module.exports = __webpack_public_path__ + "static/img/ic_weight_pop_3.f64a19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/ic_weight_pop_3.png
// module id = 9esC
// module chunks = 0